import { Component } from '@theme/component';

/** @extends {Component} */
class ProductUpsells extends Component {
  /**
   * @returns {Array<{ id: number, quantity: number }>}
   */
  getSelectedItems() {
    /** @type {Array<{ id: number, quantity: number }>} */
    const items = [];

    this.querySelectorAll('product-upsell-toggle').forEach((toggle) => {
      if (!(toggle instanceof HTMLElement)) return;

      const input = toggle.querySelector('input[type="checkbox"]');
      if (!(input instanceof HTMLInputElement) || !input.checked) return;
      if (toggle.dataset.available === 'false') return;

      const variantId = Number(toggle.dataset.variantId);
      if (!variantId) return;

      items.push({ id: variantId, quantity: 1 });
    });

    return items;
  }

  resetSelections() {
    this.querySelectorAll('product-upsell-toggle input[type="checkbox"]').forEach((input) => {
      if (input instanceof HTMLInputElement) {
        input.checked = false;
      }
    });
  }
}

if (!customElements.get('product-upsells')) {
  customElements.define('product-upsells', ProductUpsells);
}

export default ProductUpsells;
